import { atom, atomFamily, useRecoilCallback } from "recoil";
import { PolicyStatusModalConfig } from "../PolicyChangeStatusModal/PolicyStatusUtils";

type SaveQuoteAtomProps = {
  saveAction: "continue" | "save-only" | "revise-audit";
};

export type PolicyQuoteTriggerComponentNames =
  | "policyQuoteHeaderComponent"
  | "exposurePremiumFooterComponent"
  | "exposureTableHeaderComponent"
  | "agencyInformationTableComponent"
  | "generalInformationComponent"
  | "policyQuoteReadOnlyComponent"
  | "policyCustomFieldChangedComponent"
  | "validationError"
  | "endorsementCheckItem"
  | "endorsementComponent"
  | "endorsementHeaderComponent"
  | "endorsementInformationComponent"
  | "endorsementExposureTableHeaderComponent"
  | "endorsementExposurePremiumFooterComponent"
  | "endorsementPolicyKeyFieldsSave"
  | "endorsementProducerChangeSave"
  | "endorsementChildTableComponent"
  | "endorsementScheduleTableFooterComponent"
  | "auditCustomFieldChangedComponent"
  | "auditSectionChangedComponent"
  | "paymentScheduleTableComponent"
  | "refreshExposureAndPremiumByCalculations"
  | "exposureNetRateComponent";

export const TriggerPolicyQuoteUpdateAtom = atomFamily<
  string | null,
  PolicyQuoteTriggerComponentNames
>({
  key: "TriggerPolicyQuoteUpdateAtom",
  default: null,
});

export const SaveQuoteAtom = atom<SaveQuoteAtomProps | null>({
  key: "SaveQuoteAtom",
  default: null,
});

export const AuditStatusChangedModalAtom = atom<PolicyStatusModalConfig | null>(
  {
    key: "AuditStatusChangedModalAtom",
    default: null,
  }
);

export function usePolicyQuoteTriggerComponent(): {
  setPolicyQuoteTriggers: (
    componentsKeysList: PolicyQuoteTriggerComponentNames[]
  ) => void;
  clearPolicyQuoteTriggers: (
    componentsKeysList: PolicyQuoteTriggerComponentNames[]
  ) => void;
} {
  const setPolicyQuoteTriggers = useRecoilCallback(
    ({ set }) =>
      (componentsKeysList: PolicyQuoteTriggerComponentNames[]) => {
        componentsKeysList.map((key) => {
          const newRefresh = crypto.randomUUID();
          set(TriggerPolicyQuoteUpdateAtom(key as any), newRefresh);
        });
      },
    []
  );

  const clearPolicyQuoteTriggers = useRecoilCallback(
    ({ set }) =>
      (componentsKeysList: PolicyQuoteTriggerComponentNames[]) => {
        componentsKeysList.map((key) => {
          set(TriggerPolicyQuoteUpdateAtom(key as any), null);
        });
      },
    []
  );

  return { setPolicyQuoteTriggers, clearPolicyQuoteTriggers };
}

// Premium Table Rows

export const EXPOSURES_CHANGED_NAME = "exposuresChanged";

export const TriggerPolicyQuotePremiumRowUpdateAtom = atomFamily<
  string | null,
  string
>({
  key: "TriggerPolicyQuotePremiumRowUpdateAtom",
  default: null,
});

export function usePolicyQuotePremiumRowTriggerComponent(): {
  setPolicyQuotePremiumRowTriggers: (componentsKeysList: string[]) => void;
  clearPolicyQuotePremiumRowTriggers: (componentsKeysList: string[]) => void;
} {
  const setPolicyQuotePremiumRowTriggers = useRecoilCallback(
    ({ set }) =>
      (componentsKeysList: string[]) => {
        componentsKeysList.map((key) => {
          const newRefresh = crypto.randomUUID();
          set(TriggerPolicyQuotePremiumRowUpdateAtom(key as any), newRefresh);
        });
      },
    []
  );

  const clearPolicyQuotePremiumRowTriggers = useRecoilCallback(
    ({ set }) =>
      (componentsKeysList: string[]) => {
        componentsKeysList.map((key) => {
          set(TriggerPolicyQuotePremiumRowUpdateAtom(key as any), null);
        });
      },
    []
  );

  return {
    setPolicyQuotePremiumRowTriggers,
    clearPolicyQuotePremiumRowTriggers,
  };
}
